import { InferRequestType, InferResponseType } from "hono/client";
import { client } from "../client";

export const MISSIONS_QUERY_KEY = ["missions"] as const;
export const CREATE_MISSION_MUTATION_KEY = ["missions", "create"] as const;

export type MissionsResponse = InferResponseType<
  typeof client.missions.$get,
  200
>;
export type Mission = MissionsResponse[0];
export type MissionType = Mission["type"];
export type MissionObjectiveType = Mission["objectiveType"];

export type CreateMissionRequest = InferRequestType<
  typeof client.missions.$post
>["json"];

export type CreateMissionResponse = InferResponseType<
  typeof client.missions.$post,
  201
>;
